import { useState } from "react";
import { Lock } from "lucide-react";
import { adminLogin } from "@/lib/adminApi";

export default function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await adminLogin(password);
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl border border-gold/15 p-8 shadow-sm">
        <div className="w-12 h-12 rounded-full bg-honey-tint text-gold flex items-center justify-center mb-5"><Lock size={20} /></div>
        <h1 className="font-playfair text-2xl font-bold text-brown-dark mb-1">Owner Dashboard</h1>
        <p className="text-sm text-gray-500 mb-6">Enter the admin password to view orders.</p>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Admin password"
          autoComplete="current-password"
          className="w-full rounded-lg border border-gold/25 bg-cream-light px-4 py-3 text-sm outline-none focus:border-gold mb-3"
          data-testid="admin-password-input"
        />
        {error && <p className="text-red-500 text-xs mb-3" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading || !password} className="btn-gold w-full justify-center py-3 disabled:opacity-60" data-testid="admin-login-btn">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
